<template>
    <v-list class="menu">
        <v-list-item-group>
            <v-list-item class="menu-item" v-for="(item, i) in items" :key="i">
                <v-list-group
                    style="width: 100%"
                    :color="item.color"
                    v-if="item.children"
                    :value="true"
                    :prepend-icon="item.icon"
                >
                    <template v-slot:activator>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                    </template>

                    <v-list-item class="menu-item" v-for="(child, i) in item.children" :key="i" link>
                        <v-list-item-icon class="menu-item-icon">
                            <v-icon v-text="child.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title v-text="child.text"></v-list-item-title>
                    </v-list-item>
                </v-list-group>

                <template v-else>
                    <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                </template>
            </v-list-item>
        </v-list-item-group>
    </v-list>
</template>

<script>
export default {
    name: 'AdminSidebar',

    data: () => ({
        items: [
            {
                text: 'Catalogue',
                icon: 'mdi-cart',
                color: 'red',
                children: [
                    {
                        text: 'Commandes',
                        icon: 'mdi-basket',
                    },
                    {
                        text: 'Produits',
                        icon: 'mdi-basket-outline',
                    },
                    {
                        text: 'Coupons',
                        icon: 'mdi-ticket-account',
                    },
                    {
                        text: 'Packs',
                        icon: 'mdi-package-variant-closed',
                    },
                ],
            },
            {
                text: 'Statistiques',
                icon: 'mdi-equalizer',
            },
            {
                text: 'Entreprise',
                icon: 'mdi-domain',
            },
        ],
    }),
}
</script>
